<template>
  <modal-form-item v-show="!hide" :label="label" :required="required" :labelweight="labelweight" class="slimpw" :class="{'big-mode':bigBorder}" :flex_one="flex_one">
    <template slot="label">
      <slot name="label"></slot>
    </template>
    <template v-if="!hide">
      <template v-if="$slots.default || $slots[keys]">
        <slot></slot>
        <slot :name="keys"></slot>
      </template>
      <template v-else>
        <md-field :class="{
          'md-error':check && error, 
          'border-input': type !== 'chips',
        }" v-if="type!=='radio' && type!=='switch' && type!=='filter-select' && type!=='filter-tree-select' && type !=='select'">
          <!-- 输入栏 -->
          <md-input v-if="type==='input'" :style="{'width':'100%'}" :disabled="disabled" v-model="childValue" :placeholder="placeholder"/>
          <!-- 密码输入栏 -->
          <md-input v-if="type==='password'" :style="{'width':'100%'}" :disabled="disabled" v-model="childValue" :placeholder="placeholder" type="password"></md-input>
          <!-- 选择栏 -->
          <!-- <md-select v-if="type==='select'" :placeholder="placeholder" :disabled="disabled" v-model="childValue">
            <md-option v-for="item in options" :key="item.id" :value="item.id">{{item.name}}</md-option>
          </md-select> -->
          <!-- 富文本 -->
          <md-textarea v-if="type==='textarea'" :class="{'disabled-textarea': disabled}" :disabled="disabled" v-model="childValue"/>
          <!-- chips -->
          <md-chips v-if="type==='chips'" v-model="childValue" class="no-top" :md-placeholder="placeholder"/>

          <!-- 错误ICON -->
          <md-icon v-if="check && error">clear</md-icon>
        </md-field>
        <!-- 筛选树状图 选择栏 -->
        <div v-if="type==='filter-tree-select'" style="position:relative;">

          <span class="tree-row">
            <span class="el-input__suffix-inner" style="transform: rotate(180deg);">
              <i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
            </span>
          </span>
          <el-popover
            placement="bottom"
            :width="treeWeight"
            v-model="treeVisible">
            <!-- 弹窗 -->
            <div>
              <!-- 筛选-Input -->
              <div style="position: relative;">
                <common-form-item 
                  style="margin-bottom: 16px;"
                  :labelweight="100"
                  v-model="treeFilter" 
                  type="input"
                  placeholder=""
                />
                <md-icon class="search-icon">search</md-icon>
              </div>
              <!-- 部门 -->
              <tree
                ref="tree"
                node-key="_id"
                :props="treeDefaultProps"
                :data="options"
                :default-expand-all="true"
                :filter-node-method="filterNode"
              >
                <div slot-scope="{ data }">
                  <div style="padding-left: 16px;" @click="event => event.stopPropagation()">
                    <md-radio class="diy-radio-class small-size" v-model="treeRadioValue" :value="data._id">
                      <span style="font-size: 14px;color: #000;">{{ data.name }}</span>
                    </md-radio>
                  </div>
                </div>
              </tree>
                
            </div>
            <!-- 显示 -->
            <div slot="reference" style="position: relative;">
              <md-field :class="{
                'md-error':check && error, 
                'border-input': true,
              }" >
                <md-input :style="{'width':'100%'}" :disabled="true" @click="treeVisible = true" v-model="treeInputValue" :placeholder="placeholder"/>
              </md-field>
              <div v-if="!disabled" style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;"></div>
            </div>
          </el-popover>
        </div>

        <!-- 选择栏 -->
        <div v-if="type==='select'" class="slim-type">
          <el-select :placeholder="placeholder" :disabled="disabled" v-model="childValue">
            <el-option v-for="item in options" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </div>
        <!-- 筛选选择栏 -->
        <div v-if="type==='filter-select'" class="slim-type">
          <el-select :placeholder="placeholder" filterable :disabled="disabled" v-model="childValue">
            <el-option v-for="item in options" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </div>
        <!-- 单选栏 -->
        <div v-if="type==='radio'">
          <md-radio v-for="item in options" :disabled="disabled" :key="item.id" v-model="childValue" :value="item.id">{{item.name}}</md-radio>
          <!-- 提示 -->
          <md-icon v-if="help" :style="{'font-size':'20px !important','display':'inline-block'}">
            help
            <md-tooltip md-direction="right">{{help}}</md-tooltip>
          </md-icon>
        </div>
        <div v-if="type==='switch'">
          <!-- 开关 -->
          <md-switch class="small-switch" v-if="type==='switch'" v-model="childValue" />
        </div>
      </template>
    </template>
    <template slot="tail">
      <slot name="tail"></slot>
    </template>
  </modal-form-item>
</template>
<script>
const HELP = `
表单组件帮助[2025/07/07]:
  支持组件:
    input   : 输入栏
    select  : 选择栏
    textarea: 富文本框
    radio   : 单选栏
    chips   : 标签输入栏
    switch  : 按钮
  可用参数(props):
    flex_one   [Boolean - false]: 是否要flex: 1;
    bigBorder  [Boolean - false]: 是否要高点
    labelweight[Number]         : Label是否固定最小宽度
    help       [String]         : 是否有额外说明(只适用于radio)
    keys       [String]         : 放弃特定组件选择自定义Slot组件的Slot name
    check/error[Boolean - false]: 是否有输入内容与要求不符相关的UI变化(true的时候开启, 只适用于input, select, textarea, chips)
    label      [String]         : Label文本内容
    required   [Boolean - false]: Label有无必填标识"*"
    hide       [Boolean - false]: 是否隐藏
    type       [String]         : 组件类型(具体参考支持组件)
    disabled   [Boolean - false]: 是否可修改
    placeholder[String]         : Placeholder文本内容
    options    [Array]          : select/radio的选择项
  可用插件(slot):
    [keys] : 参考props中的keys
    label  : 自定义Label(可以和props的label同时使用)
    tail   : 自定义尾部
  外部常调用函数(methods):
    无
  外部自定义的函数, 组件可能会调用(emit):
    1.input: 输入内容改变时调用
`
import { Tree } from 'element-ui';
export default {
  name: "common-form-item",
  components: { Tree },
  props:{
    flex_one: {
      type: Boolean,
      default: false,
    },
    bigBorder:{
      type: Boolean,
      default: false,
    },
    labelweight: {
      type:Number,
      default:0,
    },
    help:{
      type: String,
      default:"",
    },
    keys:{
      type:String,
      default:"",
    },
    check:{ // 是否检查 this.error
      type: Boolean,
      default : false,
    },
    error:{ // 是否错误(标识)
      type: Boolean,
      default : false,
    },
    label:{ // Label
      type: String,
      default : "",
    },
    required:{ // 必填(标识)
      type: Boolean,
      default : false,
    },
    hide:{ // 是否显示
      type: Boolean,
      default : false,
    },
    type : { // 该表单组件类型
      type : String,
      default: "input",
    },
    disabled:{ //是否可修改
      type: Boolean,
      default: false,
    },
    placeholder:{ // 提示
      type: String,
      default : "",
    },
    options: { // 选择框中的选项 {value, name}
      type: Array,
      default: () => [],
    },
    treeWeight:{
      type: Number,
      default: 450,
    },
    value : null,
  },
  data(){
    return {
      childValue: this.value,

      treeVisible: false,
      treeFilter : "",
      treeInputValue: "",
      treeRadioValue: "",
      treeDefaultProps: {  // TREE 默认数据
        children: 'children',
        label: 'label'
      },
    }
  },
  watch:{
    value: {
      handler(newValue){
        if(newValue !== this.childValue){
          this.childValue = newValue
        }
        if(this.type == "filter-tree-select" && !this.treeInputValue && !this.treeRadioValue){
          var data = this.getTreeData(this.options, newValue)
          this.treeRadioValue = data._id;
          this.treeInputValue = data.name;
        }
      },
      deep: true,
      immediate: true,
    },
    treeRadioValue(value){ // _id
      this.changeTreeRadio(value)
      setTimeout(() => {
        this.treeVisible = false;
      }, 100)
    },
    childValue(newValue){
      this.$emit('input',newValue)
    },
    treeFilter(val){
      this.$refs.tree.filter(val);
    },
  },
  methods:{
    // 树状图筛选方法
    filterNode(value, data) {
      if (!value||!data) return true;
      return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    changeTreeRadio(value){
      let data = this.getTreeName(this.options, value);
      this.childValue = data.id;
      this.treeInputValue = data.name;
    },
    getTreeName(treeOptions, value){
      var data = {}
      for(let i=0; i < treeOptions.length; i++){
        if(treeOptions[i]._id == value){
          return treeOptions[i]
        }
        if(treeOptions[i].children && treeOptions[i].children.length > 0){
          data = this.getTreeName(treeOptions[i].children, value)
          if(data._id == value){
            return data
          }
        }
      }
      return data
    },
    getTreeData(treeOptions, value){
      var data = {}
      for(let i=0; i < treeOptions.length; i++){
        if(treeOptions[i].id == value){
          return treeOptions[i]
        }
        if(treeOptions[i].children && treeOptions[i].children.length > 0){
          data = this.getTreeData(treeOptions[i].children, value)
          if(data.id == value){
            return data
          }
        }
      }
      return data
    },
    _help(){
      console.log(HELP);
    },
  },
  // components: {
  //   Modal,
  // },

}
</script>
<style scoped>
  .search-icon{
    font-size: 18px !important; 
    position: absolute;
    right: 4px;
    top: 2px;
    cursor: pointer;
  }
  .disabled-textarea{
    cursor: no-drop !important;
  }
  .slim-type{
    height: 26px;
    overflow: hidden;
    display: flex;
    align-items: center;
    border: 0.5px solid rgb(126, 126, 126) !important;
    border-radius: 4px;
  }
  .slim-type ::v-deep .el-select{
    width: 100%;
  }
  .slimpw /deep/ .md-field .md-input-action{
    width    : 22px;
    height   : 22px;
    min-width: 22px;
  }
  .tree-row{
    transform: rotate(180deg);
    position: absolute;
    height: 100%;
    right: 5px;
    top: 6px;
    text-align: center;
    color: #C0C4CC;
    transition: all 0.3s;
    pointer-events: none;
  }
</style>